import { render, staticRenderFns } from "./addPpc.vue?vue&type=template&id=b26beec6&scoped=true"
import script from "./addPpc.vue?vue&type=script&lang=js"
export * from "./addPpc.vue?vue&type=script&lang=js"
import style0 from "./addPpc.vue?vue&type=style&index=0&id=b26beec6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b26beec6",
  null
  
)

export default component.exports